/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [{
    url: "/packages/list",
    name: "Pedidos",
    slug: "pedidos",
    icon: "ListIcon",
  },
  {
    url: "/credentials/sigep",
    name: "Credenciais",
    slug: "credenciais",
    icon: "LockIcon",
  },
  {
    url: 'https://help.gadolapps.com/',
    target: "_blank",
    name: "Suporte",
    slug: "suporte",
    icon: "SmileIcon",    
  }
]
